import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@lenovo/material/menu';
import { MatTooltipModule } from '@lenovo/material/tooltip';
import { MatCheckboxModule } from '@lenovo/material/checkbox';
import { MatButtonModule } from '@lenovo/material/button';
import { MatProgressBarModule } from '@lenovo/material/progress-bar';
import { MatInputModule } from '@lenovo/material/input';
import { MaterialCheckboxComponent } from 'src/app/material/checkbox/material-checkbox.component';
import { MaterialButtonComponent } from 'src/app/material/button/material-button.component';
import { MaterialSliderComponent } from 'src/app/material/slider/material-slider.component';
import { MaterialSlideToggleComponent } from 'src/app/material/material-slide-toggle/material-slide-toggle.component';
import { MatSliderModule } from '@lenovo/material/slider';
import { MatSlideToggleModule } from '@lenovo/material/slide-toggle';
import { SpinnerModule } from 'src/app/components/common/spinner/spinner.module';
import { MaterialSelectComponent } from 'src/app/material/select/material-select.component';
import { MatFormFieldModule } from '@lenovo/material/form-field'; // into your own component module file;
import { MatSelectModule } from '@lenovo/material/select'; // into your own component module file;
import { MatIconModule } from '@lenovo/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [MaterialCheckboxComponent, MaterialButtonComponent, MaterialSliderComponent, MaterialSlideToggleComponent, MaterialSelectComponent],
	exports: [
		CommonModule,
		MaterialCheckboxComponent,
		MaterialButtonComponent,
		MatCheckboxModule,
		MatProgressBarModule,
		MatTooltipModule,
		MatInputModule,
		MatMenuModule,
		MatButtonModule,
		MaterialSliderComponent,
		MaterialSelectComponent,
		MaterialSlideToggleComponent
	],
	imports: [
		CommonModule,
		MatCheckboxModule,
		MatProgressBarModule,
		MatTooltipModule,
		MatInputModule,
		MatMenuModule,
		MatButtonModule,
		MatSliderModule,
		MatSlideToggleModule,
		SpinnerModule,
		MatFormFieldModule,
		MatSelectModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		MatSlideToggleModule,
		SpinnerModule,
		ReactiveFormsModule
	],
})
export class CommonMaterialModule {}
